document.addEventListener("DOMContentLoaded", () => {
  const href = location.href;
  const productsDataArr = [];
  const i = href.indexOf("?page=");

  if (i != -1) {
    window.location = href.substring(0, i);
  }

  let currentPageNumber = 1;

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains('collection-load-more')) {
      const loadMoreButton = document.querySelector(".collection-load-more");
      let limitNumber = parseInt(loadMoreButton.getAttribute("limit"));

      const productContainer = document.querySelector(".collection__products .product-grid");

      const j = href.indexOf("/collections/");
      const _url = location.href
      ++currentPageNumber;
      const hasParams = _url.includes('?') && _url.split('?')[1].length > 0;
      let url = `${location.href.substring(j)}?page=${currentPageNumber}`;
      if(hasParams) {
        url = `${location.href.substring(j)}&page=${currentPageNumber}`;
      }
      fetch(url)
        .then((res) => res.text())
        .then((res) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(res, "text/html");
          const productItems = html.querySelectorAll(".product-item");
          if (productItems.length > 0) {
            for(let i = 0; i < productItems.length; i++) {
              productContainer.appendChild(productItems[i]);
            }
            
            // setTimeout(() => {
            //   productItems.forEach((product) => {
            //     const productId = product.dataset.productId;
            //     fetch(
            //       product.querySelector(".product-link").getAttribute("href") +
            //         ".js"
            //     )
            //       .then((res) => res.json())
            //       .then((res) => {
            //         productsDataArr.push(res);
            //         let colorCountContent = "";
            //         let colorSwatches = "";
            //         const colorArr = [];
            //         let isExistColor = false;
            //         for (const option of res.options) {
            //           const downCasedText = option.name.toLowerCase();
            //           if(downCasedText === 'color' || downCasedText === 'colour') {
            //               isExistColor = true;
            //               break;
            //           }
            //         }
            //         for (const option of res.options) {
            //           const downCasedText = option.name.toLowerCase();
            //           if(isExistColor) {
            //               if(downCasedText !== 'color' && downCasedText !== 'colour') {
            //                   continue;
            //               }
            //           }
            //           if (
            //             downCasedText === "color" ||
            //             downCasedText === "colour" ||
            //             downCasedText === "metal" ||
            //             downCasedText === "material"
            //           ) {
            //             option.values.forEach((color) => {
            //               for (const variant of res.variants) {
            //                 let isMatched = false;
            //                 for (const variant_option of variant.options) {
            //                   if (variant_option === color) {
            //                     if (colorArr.indexOf(color) !== -1) {
            //                       isMatched = true;
            //                       break;
            //                     }
            //                     colorSwatches += `
            //                                     <span class="swatch__button" data-swatch-button="" data-fades-in="" data-tooltip="${color}">
            //                                         <input type="radio" name="grouped" value="${color}" id="${res.id}-${variant.id}">
            //                                         <label for="${res.id}-${variant.id}" data-swatch="${color}" data-swatch-variant="${variant.id}" data-swatch-image="${variant.featured_image.src}" style="--swatch: ${color};">
            //                                         <span class="visually-hidden">${color}</span>
            //                                         </label>
            //                                     </span>`;
            //                     colorArr.push(color);
            //                     isMatched = true;
            //                     break;
            //                   }
            //                 }
            //                 if (isMatched) {
            //                   break;
            //                 }
            //               }
            //             });
            //             break;
            //           }
            //         }
            //         if (colorArr.length > 0) {
            //           colorCountContent = `<span class="grid__product-swatches-count" data-swatch-count="">${colorArr.length} color</span>`;
            //         } else {
            //           colorSwatches = "";
            //         }
            //         const swatchContainer = product.querySelector(
            //           ".selector-wrapper__scrollbar"
            //         );
            //         const colorSwatchCount = product.querySelector(
            //           ".grid__product-swatches-count"
            //         );
            //         if (swatchContainer) {
            //           swatchContainer.innerHTML = colorSwatches;
            //         }
            //         product
            //           .querySelectorAll(".swatch__button")
            //           .forEach((item) => {
            //             let swatch = new Swatch(item.querySelector("label"));
            //             new Tooltip(item);
            //           });
            //         if (colorSwatchCount) {
            //           colorSwatchCount.innerHTML = `${colorArr.length} color`;
            //         }
            //         document.querySelector(`[data-product-id="${productId}"`).innerHTML = product.innerHTML;
            //       });
            //   });
            // }, 500);
            
            if (productItems.length < limitNumber) {
              loadMoreButton.style.display = "none";
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  });

  const selectors$g = {
    formGridSwatch: "[data-grid-swatch-form]",
    swatch: "data-swatch",
    outerGrid: "[data-product-grid-item]",
    // slide: '[data-grid-slide]',
    slide: ".product-item__bg",
    image: "data-swatch-image",
    variant: "data-swatch-variant",
    button: "[data-swatch-button]",
    link: ".product-link",
    wrapper: "[data-grid-swatches]",
    template: "[data-swatch-template]",
    handle: "data-swatch-handle",
    label: "data-swatch-label",
    tooltip: "data-tooltip",
    swatchCount: "data-swatch-count",
    scrollbar: "data-scrollbar",
  };
  const defaults = {
    color: "ash",
  };
  const classes$5 = {
    visible: "is-visible",
    stopEvents: "no-events",
  };
  const selectors$8 = {
    tooltip: "data-tooltip",
    tooltipStopMouseEnter: "data-tooltip-stop-mouseenter",
  };
  const classes$1 = {
    tooltipDefault: "poppy__tooltip",
  };
  const classes$E = {
    tooltipDefault: "tooltip-default",
    visible: "is-visible",
    hiding: "is-hiding",
  };
  const selectors$M = {
    tooltip: "data-tooltip",
    tooltipStopMouseEnter: "data-tooltip-stop-mouseenter",
  };
  function t(t) {
    var e = t.getBoundingClientRect(),
      i = e.left,
      n = e.right,
      o = e.top,
      s = e.bottom,
      r = window.pageYOffset;
    return {
      height: s - o,
      width: n - i,
      top: { y: r + o, x: i + (n - i) / 2 },
      bottom: { y: r + s, x: i + (n - i) / 2 },
      left: { y: o + (s - o) / 2, x: i },
      right: { y: o + (s - o) / 2, x: n },
      topLeft: { y: r + o, x: i },
      bottomLeft: { y: r + s, x: i },
      topRight: { y: r + o, x: n },
      bottomRight: { y: r + s, x: n },
    };
  }
  function e(e, i, n) {
    var o = t(i)[n],
      s = t(e),
      r = window.pageYOffset,
      a = {
        top: r,
        bottom: r + window.innerHeight,
        left: 0,
        right: window.innerWidth,
      },
      h = {
        top: { x: s.width / 2, y: s.height },
        bottom: { x: s.width / 2, y: 0 },
        left: { x: s.width, y: s.height / 2 },
        right: { x: 0, y: s.height / 2 },
        topLeft: { x: s.width, y: s.height },
        topRight: { x: 0, y: s.height },
        bottomLeft: { x: s.width, y: 0 },
        bottomRight: { x: 0, y: 0 },
      },
      p = o.x - h[n].x,
      u = o.y - h[n].y;
    p < a.left
      ? (p = a.left)
      : p + s.width > a.right && (p = a.right - s.width),
      u < a.top
        ? (u = a.top)
        : u + s.height > a.bottom && (u = a.bottom - s.height),
      (e.style.transform =
        "translateX(" +
        Math.round(p) +
        "px) translateY(" +
        Math.round(u) +
        "px)");
  }
  function d(t) {
    t.length > 0 && t.shift().apply(this, t);
  }
  function n(t, e) {
    t(), d(e);
  }
  function o(t, e) {
    return function () {
      var i = [].slice.call(arguments),
        s = i[0];
      if ("number" == typeof s) return o(t, s);
      "number" == typeof e
        ? setTimeout(function () {
            n(t, i);
          }, e)
        : n(t, i);
    };
  }
  function s() {
    var t = [].slice.call(arguments);
    return o(function () {
      d(t.slice(0));
    });
  }
  var r = function (t) {
    var e = t.popover;
    void 0 === e && (e = null);
    var i = t.position;
    void 0 === i && (i = "bottom");
    var n = t.transitionSpeed;
    void 0 === n && (n = 0);
    var o = t.onChange;
    void 0 === o && (o = null),
      (this.target = t.target),
      (this.popover = this.createPopover(e)),
      (this.position = i),
      (this.transitionSpeed = n),
      (this.onChange = o),
      (this.state = { pinned: !1, busy: !1, requestClose: !1 }),
      (this.pin = this.pin.bind(this)),
      (this.unpin = this.unpin.bind(this)),
      (this.block = this.block.bind(this)),
      (this.unblock = this.unblock.bind(this)),
      (this.isExternalClick = this.isExternalClick.bind(this)),
      (this.handleKeyup = this.handleKeyup.bind(this)),
      (this.focusNode = null);
  };
  (r.prototype.setState = function (t, e) {
    (this.state = Object.assign(this.state, t)), e && o(e, 0)();
  }),
    (r.prototype.block = function () {
      this.setState({ busy: !0 });
    }),
    (r.prototype.unblock = function () {
      var t = this;
      this.setState({ busy: !1 }, function () {
        t.state.requestClose && t.unpin();
      });
    }),
    (r.prototype.toggle = function () {
      this.state.pinned ? this.unpin() : this.pin();
    }),
    (r.prototype.pin = function () {
      var t = this;
      if (!this.state.busy && !this.state.pinned) {
        this.setState({ busy: !0 }), (this.focusNode = document.activeElement);
        var i = o(function () {
            return document.body.appendChild(t.popover);
          }),
          n = o(function () {
            return (
              (n = t.target),
              (o = t.position),
              (i = t.popover).classList.add("is-tacked"),
              e(i, n, o),
              {
                update: function () {
                  e(i, n, o);
                },
                destroy: function () {
                  (i.style.transform = ""), i.classList.remove("is-tacked");
                },
              }
            );
            var i, n, o;
          }),
          r = o(function () {
            t.popover.classList.add("is-visible"),
              t.popover.setAttribute("tabindex", "0"),
              t.popover.setAttribute("aria-hidden", "false");
          }),
          a = o(function () {
            return t.popover.focus();
          }),
          h = o(function () {
            return t.setState({ busy: !1, pinned: !0 });
          });
        s(i, n, r(0), a(0), h)(),
          this.popover.addEventListener("mouseenter", this.block),
          this.popover.addEventListener("mouseleave", this.unblock),
          window.addEventListener("click", this.isExternalClick),
          window.addEventListener("touchstart", this.isExternalClick),
          window.addEventListener("keyup", this.handleKeyup),
          window.addEventListener("resize", this.unpin),
          this.onChange && this.onChange({ pinned: !0 });
      }
    }),
    (r.prototype.unpin = function (t) {
      var e = this;
      this.setState({ requestClose: !0 }),
        (t || (!this.state.busy && this.state.pinned)) &&
          o(function () {
            e.setState({ busy: !0 }),
              e.popover.removeEventListener("mouseenter", e.block),
              e.popover.removeEventListener("mouseleave", e.unblock),
              window.removeEventListener("click", e.isExternalClick),
              window.removeEventListener("touchstart", e.isExternalClick),
              window.removeEventListener("keyup", e.handleKeyup),
              window.removeEventListener("resize", e.unpin);
            var t = o(function () {
                return e.popover.classList.add("is-hiding");
              }),
              i = o(function () {
                e.popover.remove();
                return e.popover;
                // return document.body.removeChild(e.popover);
              }),
              n = o(function () {
                return e.focusNode.focus();
              }),
              r = o(function () {
                e.popover.classList.remove("is-hiding"),
                  e.popover.classList.remove("is-visible"),
                  e.setState({ busy: !1, pinned: !1, requestClose: !1 });
              });
            s(t, i(e.transitionSpeed), n, r)(),
              e.onChange && e.onChange({ pinned: !1 });
          }, 0)();
    }),
    (r.prototype.handleKeyup = function (t) {
      27 === t.keyCode && this.unpin();
    }),
    (r.prototype.isExternalClick = function (t) {
      t.target === this.popover ||
        this.popover.contains(t.target) ||
        t.target === this.target ||
        this.target.contains(t.target) ||
        this.unpin();
    }),
    (r.prototype.createPopover = function (t) {
      var e = document.createElement("div");
      return (
        (e.className = "poppy"),
        (e.role = "dialog"),
        e.setAttribute("aria-label", "Share Dialog"),
        e.setAttribute("aria-hidden", "true"),
        "string" == typeof t ? (e.innerHTML = t) : e.appendChild(t),
        e
      );
    });
  class ColorMatch {
    constructor(options = {}) {
      this.settings = {
        ...defaults,
        ...options,
      };

      this.match = this.init();
    }

    getColor() {
      return this.match;
    }

    init() {
      const getColors = loadScript({ json: window.theme.assets.swatches });
      return getColors
        .then((colors) => {
          return this.matchColors(colors, this.settings.color);
        })
        .catch((e) => {
          console.log("failed to load swatch colors script");
          console.log(e);
        });
    }

    matchColors(colors, name) {
      let bg = "#E5E5E5";
      let img = null;
      const path = window.theme.assets.base || "/";
      const comparisonName = name.toLowerCase().replace(/\s/g, "");
      const array = colors.colors;

      if (array) {
        let indexArray = null;

        const hexColorArr = array.filter((colorObj, index) => {
          const neatName = Object.keys(colorObj)
            .toString()
            .toLowerCase()
            .replace(/\s/g, "");

          if (neatName === comparisonName) {
            indexArray = index;

            return colorObj;
          }
        });

        if (hexColorArr.length && indexArray !== null) {
          const value = Object.values(array[indexArray])[0];
          bg = value;

          if (
            value.includes(".jpg") ||
            value.includes(".jpeg") ||
            value.includes(".png") ||
            value.includes(".svg")
          ) {
            img = `${path}${value}`;
            bg = "#888888";
          }
        }
      }

      return {
        color: this.settings.color,
        path: img,
        hex: bg,
      };
    }
  }

  class Swatch {
    constructor(element) {
      this.element = element;
      this.colorString = element.getAttribute(selectors$g.swatch);
      this.image = element.getAttribute(selectors$g.image);
      this.variant = element.getAttribute(selectors$g.variant);
      const matcher = new ColorMatch({ color: this.colorString });
      matcher.getColor().then((result) => {
        this.colorMatch = result;
        this.init();
      });
    }

    init() {
      this.setStyles();
      if (this.variant) {
        this.handleEvents();
      }
    }

    setStyles() {
      if (this.colorMatch.hex) {
        switch (this.colorMatch.color) {
          case "Light Rose":
            this.colorMatch.hex = "#F3C5CD";
            break;
          case "Sky Blue":
            this.colorMatch.hex = "#A0C7F2";
            break;
          case "Violet":
            this.colorMatch.hex = "#E3CCE9";
            break;
          case "Sage Green":
            this.colorMatch.hex = "#8FCEC2";
            break;
          default:
        }
        this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`);
      }
      if (this.colorMatch.path) {
        this.element.style.setProperty(
          "background-image",
          `url(${this.colorMatch.path})`
        );
        this.element.style.setProperty("background-size", "cover");
        this.element.style.setProperty("background-position", "center center");
      }
    }

    handleEvents() {
      this.outer = this.element.closest(selectors$g.outerGrid);
      if (this.outer) {
        this.slide = this.outer.querySelector(selectors$g.slide);

        this.linkElement = this.outer.querySelector(selectors$g.link);
        this.linkElementAll = this.outer.querySelectorAll(selectors$g.link);
        this.linkDestination = getUrlWithVariant(
          this.linkElement.getAttribute("href"),
          this.variant
        );
        this.button = this.element.closest(selectors$g.button);

        if (this.button.closest(selectors$g.formGridSwatch)) {
          this.button.addEventListener(
            "mouseenter",
            function () {
              this.changeImage();
            }.bind(this)
          );
        }

        if (!this.button.closest(selectors$g.formGridSwatch)) {
          this.button.addEventListener(
            "click",
            function () {
              this.changeImage();
            }.bind(this)
          );
        }
      }
    }

    changeImage() {
      this.linkElementAll.forEach((link) => {
        link.setAttribute("href", this.linkDestination);
      });

      this.slide.setAttribute("src", this.linkDestination);
      const variant_image = getVariantImage(
        productsDataArr,
        this.element.getAttribute("data-swatch-variant")
      );
      this.slide.style.backgroundImage = `url(${variant_image})`;
      // this.slide.setAttribute("srcset", "");
    }
  }
  class Tooltip {
    constructor(el, options = {}) {
      this.tooltip = el;
      if (!this.tooltip.hasAttribute(selectors$M.tooltip)) return;
      this.label = this.tooltip.getAttribute(selectors$M.tooltip);
      this.class = options.class || classes$E.tooltipDefault;
      this.transitionSpeed = options.transitionSpeed || 200;
      this.hideTransitionTimeout = 0;
      this.addPinEvent = () => this.addPin();
      this.addPinMouseEvent = () => this.addPin(true);
      this.removePinEvent = (event) => throttle(this.removePin(event), 50);
      this.removePinMouseEvent = (event) => this.removePin(event, true, true);
      this.init();
    }

    init() {
      if (!document.querySelector(`.${this.class}`)) {
        const tooltipTemplate = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`;
        const tooltipElement = document.createElement('div');
        tooltipElement.className = this.class;
        tooltipElement.innerHTML = tooltipTemplate;
        document.body.appendChild(tooltipElement);
      }

      this.tooltip.addEventListener('mouseenter', this.addPinMouseEvent);
      this.tooltip.addEventListener('mouseleave', this.removePinMouseEvent);
      this.tooltip.addEventListener('theme:tooltip:init', this.addPinEvent);
      document.addEventListener('theme:tooltip:close', this.removePinEvent);
    }

    addPin(stopMouseEnter = false) {
      const tooltipTarget = document.querySelector(`.${this.class}`);

      if (tooltipTarget && ((stopMouseEnter && !this.tooltip.hasAttribute(selectors$M.tooltipStopMouseEnter)) || !stopMouseEnter)) {
        const tooltipTargetArrow = tooltipTarget.querySelector(`.${this.class}__arrow`);
        const tooltipTargetInner = tooltipTarget.querySelector(`.${this.class}__inner`);
        const tooltipTargetText = tooltipTarget.querySelector(`.${this.class}__text`);
        tooltipTargetText.textContent = this.label;

        const tooltipTargetWidth = tooltipTargetInner.offsetWidth;
        const tooltipRect = this.tooltip.getBoundingClientRect();
        const tooltipTop = tooltipRect.top;
        const tooltipWidth = tooltipRect.width;
        const tooltipHeight = tooltipRect.height;
        const tooltipTargetPositionTop = tooltipTop + tooltipHeight + window.scrollY;
        let tooltipTargetPositionLeft = tooltipRect.left - tooltipTargetWidth / 2 + tooltipWidth / 2;
        const tooltipLeftWithWidth = tooltipTargetPositionLeft + tooltipTargetWidth;
        const tooltipTargetWindowDifference = tooltipLeftWithWidth - getWindowWidth();

        if (tooltipTargetWindowDifference > 0) {
          tooltipTargetPositionLeft -= tooltipTargetWindowDifference;
        }

        if (tooltipTargetPositionLeft < 0) {
          tooltipTargetPositionLeft = 0;
        }

        tooltipTargetArrow.style.left = `${tooltipRect.left + tooltipWidth / 2}px`;
        tooltipTarget.style.setProperty('--tooltip-top', `${tooltipTargetPositionTop}px`);
        tooltipTargetInner.style.transform = `translateX(${tooltipTargetPositionLeft}px)`;
        tooltipTarget.classList.remove(classes$E.hiding);
        tooltipTarget.classList.add(classes$E.visible);

        document.addEventListener('theme:scroll', this.removePinEvent);
      }
    }

    removePin(event, stopMouseEnter = false, hideTransition = false) {
      const tooltipTarget = document.querySelector(`.${this.class}`);
      const tooltipVisible = tooltipTarget.classList.contains(classes$E.visible);

      if (tooltipTarget && ((stopMouseEnter && !this.tooltip.hasAttribute(selectors$M.tooltipStopMouseEnter)) || !stopMouseEnter)) {
        if (tooltipVisible && (hideTransition || event.detail.hideTransition)) {
          tooltipTarget.classList.add(classes$E.hiding);

          if (this.hideTransitionTimeout) {
            clearTimeout(this.hideTransitionTimeout);
          }

          this.hideTransitionTimeout = setTimeout(() => {
            tooltipTarget.classList.remove(classes$E.hiding);
          }, this.transitionSpeed);
        }

        tooltipTarget.classList.remove(classes$E.visible);

        document.removeEventListener('theme:scroll', this.removePinEvent);
      }
    }

    unload() {
      this.tooltip.removeEventListener('mouseenter', this.addPinMouseEvent);
      this.tooltip.removeEventListener('mouseleave', this.removePinMouseEvent);
      this.tooltip.removeEventListener('theme:tooltip:init', this.addPinEvent);
      document.removeEventListener('theme:tooltip:close', this.removePinEvent);
      document.removeEventListener('theme:scroll', this.removePinEvent);
    }
  }
  const loaders = {};
  function loadScript(options = {}) {
    if (!options.type) {
      options.type = "json";
    }

    if (options.url) {
      if (loaders[options.url]) {
        return loaders[options.url];
      } else {
        return getScriptWithPromise(options.url, options.type);
      }
    } else if (options.json) {
      if (loaders[options.json]) {
        return Promise.resolve(loaders[options.json]);
      } else {
        return window
          .fetch(options.json)
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            loaders[options.json] = response;
            return response;
          });
      }
    } else if (options.name) {
      const key = "".concat(options.name, options.version);
      if (loaders[key]) {
        return loaders[key];
      } else {
        return loadShopifyWithPromise(options);
      }
    } else {
      return Promise.reject();
    }
  }
  function getWindowWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }
  function getUrlWithVariant(url, id) {
    if (/variant=/.test(url)) {
      return url.replace(/(variant=)[^&]+/, "$1" + id);
    } else if (/\?/.test(url)) {
      return url.concat("&variant=").concat(id);
    }

    return url.concat("?variant=").concat(id);
  }
  const getVariantImage = (productsData, variant_id) => {
    if (!variant_id) {
      return "";
    }
    for (const productData of productsData) {
      let variant_image;
      for (const variant of productData.variants) {
        if (variant.id == variant_id) {
          variant_image = variant.featured_image?.src;
          if (!variant_image) {
            variant_image = productData.featured_image;
          }
          break;
        }
      }
      if (variant_image) {
        return variant_image;
      }
    }
    return "";
  };
});
